import { isProcessingAuthorizedBooking } from "./isProcessingAuthorizedBooking";

export function shouldStopBookingStatusPolling(bookingStatus: any, apiError: boolean): boolean {
  if (apiError) {
    return true;
  }

  const isProcessingYellowBookings =
    !bookingStatus?.directly_bookable && bookingStatus?.payment_status === "authorized";
  const isProcessingAuthorized = isProcessingAuthorizedBooking(bookingStatus);

  return (
    isProcessingAuthorized ||
    isProcessingYellowBookings ||
    bookingStatus?.booking_status === "booked" ||
    bookingStatus?.booking_status === "cancelled" ||
    bookingStatus?.booking_status === "error" ||
    bookingStatus?.payment_status === "paid"
  );
}
